const en = {
  direction: 'ltr',
  language_flag_icon_path: 'assets/images/ukflag.png',
  lang: 'english',
  menu: {
    home: 'home',
    about_us: 'about us',
    contact_us: 'contact us',
    instant_price: 'instant price',
    blog: 'blog',
    login: 'login',
    register: 'register',
    user_area: 'dashboard',
    app_download: 'download mobile app',
  },
  last_trades: 'Last trades in the last 24 hours',
  home_page_title: 'arzine | sale & buy',
  why_us: 'why us ?',
  user_comments: 'user comments',
  enter_number: 'enter your number',
  registered_before: 'have you registered before?',
  go_login: 'login',
  forget_number: 'Forgot your number?',
  login_with_email: 'login with email',
  login_with_number: 'login with number',
  enter_email: 'enter your email',
  forget_email: 'Forgot your email?',
  enter_sended_code: 'Enter code',
  verify_code: 'Verify code',
  do_not_receive_code: 'did not receive the verification code?',
  receive_code_again: 'Retrieve the verification code',
};

export default en;